import { colors, typography } from '@/designSystem/index';
import styled from 'styled-components';

export const Container = styled.div`
  ${typography.sm}
  color: ${colors.text};
  font-weight: 400;
  margin: 32px 0;
`;
